import { render, staticRenderFns } from "./EditInvoice.vue?vue&type=template&id=2164b49c&scoped=true"
import script from "./EditInvoice.vue?vue&type=script&lang=ts"
export * from "./EditInvoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164b49c",
  null
  
)

export default component.exports